import { render, staticRenderFns } from "./CreateWatches.vue?vue&type=template&id=b1242318&scoped=true"
import script from "./CreateWatches.vue?vue&type=script&lang=js"
export * from "./CreateWatches.vue?vue&type=script&lang=js"
import style0 from "./CreateWatches.vue?vue&type=style&index=0&id=b1242318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1242318",
  null
  
)

export default component.exports